import { Navigate } from "react-router-dom";

export default function V2AdvaImpersonatePage() {
  return <Navigate to="/settings/adva/users" replace />;
}
